import { APP_ROUTES } from '../../../constants/routes';
import { TBreacdcrumbData } from './BreadcrumbsBlock.types';

export const HOME_BREADCRUMB: TBreacdcrumbData = {
  label: 'Home',
  to: APP_ROUTES.HOME,
};
